import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const UserAuditFeedbackModel = types
  .model('UserAuditFeedbackModel', {
    data: types.frozen()
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_FEEDBACK_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response);
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_FEEDBACK_RESPONSE);
    },
    resetStoreValues() {
      const initialState = { data: {} };
      applySnapshot(self, initialState);
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_FEEDBACK_RESPONSE);
    }
  }));

export default UserAuditFeedbackModel;
